import React, {useEffect, useState} from 'react';
import {Range} from 'react-range';
import './FilterPrice.css';

function FilterPrice(props) {
  const [state, setState] = useState({
    from: props.VALUES[0].HTML_VALUE
        ? Number(props.VALUES[0].HTML_VALUE)
        : Number(props.VALUES[0].VALUE),
    to: props.VALUES[1].HTML_VALUE
        ? Number(props.VALUES[1].HTML_VALUE)
        : Number(props.VALUES[1].FILTERED_VALUE) || Number(props.VALUES[1].VALUE),
  });

  const [baseState, setBaseState] = useState({
    from: props.VALUES[0].HTML_VALUE
        ? Number(props.VALUES[0].HTML_VALUE)
        : Number(props.VALUES[0].VALUE),
    to: props.VALUES[1].HTML_VALUE
        ? Number(props.VALUES[1].HTML_VALUE)
        : Number(props.VALUES[1].FILTERED_VALUE) || Number(props.VALUES[1].VALUE),
  });

  const min = Number(props.VALUES[0].HTML_VALUE ? Math.min(props.VALUES[0].HTML_VALUE, props.VALUES[0].VALUE) : props.VALUES[0].VALUE);

  const max = Number(props.VALUES[1].HTML_VALUE ? Math.max(props.VALUES[1].HTML_VALUE, props.VALUES[1].FILTERED_VALUE) : props.VALUES[1].FILTERED_VALUE || props.VALUES[1].VALUE);

  const [opened, setOpened] = useState(true);

  useEffect(() => {
    const fromValue = props.VALUES[0].HTML_VALUE ? Number(
        props.VALUES[0].HTML_VALUE) : Number(
        props.VALUES[0].VALUE);
    const toValue = props.VALUES[1].HTML_VALUE
        ? Number(props.VALUES[1].HTML_VALUE)
        : Number(props.VALUES[1].FILTERED_VALUE) || Number(props.VALUES[1].VALUE);

    setBaseState({from: fromValue, to: toValue});
    setState({...state, from: fromValue, to: toValue});
    setInputValues([fromValue, toValue]);
  }, [props.VALUES]);

  function onChangeRange(values) {
    setState({from: Number(values[0]), to: Number(values[1])});
    setInputValues([Number(values[0]), Number(values[1])]);
  }

  function onClick(event) {
    event.preventDefault();
    props.onChange(props.ASYNC_URL, state.from, state.to);
  }

  const title = props.messages && props.messages.hasOwnProperty(props.CODE) ?
      props.messages[props.CODE] : '';

  const [inputValues, setInputValues] = useState([state.from, state.to]);

  const showApply = !props.isMobile || baseState.from !== state.from ||
      baseState.to !== state.to;

  const numberInputProps = {
    step: 1,
    type: 'number'
  }

  return (
      <>
        {
          !Number.isNaN(state.from) && !Number.isNaN(state.to) && !(min === 0 && max === 0) && min !== max ?
              <div className={`filter-box ${opened ? 'active' : ''} price-box`}>
                <div className="filter-box__title"
                     onClick={() => (setOpened(!opened))}>{title}</div>
                <div className={`filter-box__container ${!opened
                    ? 'collapsed'
                    : ''}`}>
                  <div className="parameters-block">
                    <Range
                        step={10}
                        min={min}
                        max={max}
                        values={[state.from, state.to]}
                        onChange={onChangeRange}
                        renderTrack={({props, children}) => (
                            <div
                                {...props}
                                style={{
                                  ...props.style,
                                  height: '3px',
                                  width: '100%',
                                  backgroundColor: '#d8d8d8',
                                }}
                            >
                              {children}
                            </div>
                        )}
                        renderThumb={({props}) => {
                          return <span
                              className={`price-thumb-${props.key + 1}`}
                              {...props}
                              style={{
                                ...props.style,
                                height: '24px',
                                width: '19px',
                                backgroundColor: 'none',
                              }}
                          />;
                        }}
                    />
                    <div className="filter-parameters">
                      <div className="filter-parameters-box bx-left">
                        <div className="bx-filter-input-container">
                          <input
                              value={inputValues[0]}
                              onBlur={event => {
                                let value = Number(event.target.value);
                                if (value < min || value >= state.to) {
                                  setInputValues([state.from, state.to]);
                                } else {
                                  setState({...state, from: value});
                                }
                              }}
                              onChange={event => {
                                let value = Number(event.target.value);
                                if (!isNaN(value)) {
                                  setInputValues([value, inputValues[1]]);
                                }
                              }}/>
                        </div>
                      </div>
                      <div className="filter-parameters-box bx-right">
                        <div className="bx-filter-input-container">
                          <input
                              value={inputValues[1]}
                              onBlur={event => {
                                let value = Number(event.target.value);
                                if (value > max || value <= state.from) {
                                  setInputValues([state.from, state.to]);
                                } else {
                                  setState({...state, to: value});
                                }
                              }}
                              onChange={(event) => {
                                let value = Number(event.target.value);
                                if (!isNaN(value)) {
                                  setInputValues([inputValues[0], value]);
                                }
                              }}/>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    showApply ?
                        <a className="set-filter-price"
                           onClick={onClick}>
                          {props.messages.CT_BCSF_FILTER_APPLY}
                        </a> :
                        <></>
                  }
                </div>
              </div> :
              <></>
        }
      </>
  );
}

export default FilterPrice;